module.exports = __webpack_public_path__ + "img/DE02329.73e9d596.png";